import React, { FC, useEffect, useRef, useState } from 'react';
import MultiInputItem from './item/MultiInputItem';
import { Dirary } from '../../../types/dirary';
import classes from './MultiInputDetail.module.scss';
import { useTheme } from '@mui/material';
import { Buttons } from '../../uikit/atoms/buttons/Buttons';
import SendIcon from '@mui/icons-material/Send';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
//追加
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ScrollButton from '../../uikit/atoms/buttons/ScrollButton';
import { useNavigate } from 'react-router-dom';
import { useAddPosts } from '../../../hooks/api/posts/useAddPosts';
import { useDeletePosts } from '../../../hooks/api/posts/useDeletePosts';
import { useUpdatePosts } from '../../../hooks/api/posts/useUpdatePosts';
import { useRecoilState } from 'recoil';
import {
  diaryListState,
  diaryListStateForMatrix,
} from '../../../states/diaryListState';
import { postIdCounterState } from '../../../states/postIdCounterState';
import { WorkerWithDiary } from '../../../types';
import { useSubmitGuard } from '../../../hooks/util/useSubmitGuard';

type Props = {
  diaryList: Array<Dirary>;
  // addDiaryList: Array<Dirary>;
  // deleteDiaryList: Array<Dirary>;
  // updateDiaryList: Array<Dirary>;
  setDiaryList: React.Dispatch<React.SetStateAction<Array<Dirary>>>;
  defaultDiary: Dirary;
  isSendable: boolean;
  totalTime: { hour: number; min: number; text: string };
  setTotalTime: React.Dispatch<
    React.SetStateAction<{ hour: number; min: number; text: string }>
  >;
  setWorkerList: React.Dispatch<React.SetStateAction<Array<WorkerWithDiary>>>;
  workerList: Array<WorkerWithDiary>;
  fromTime: string;
  shiftType: number; //夜勤2直対応: Main→Item へ中継
  isOverMaxChain: boolean; //夜勤2直対応(brush-up): 24h超で赤アラート表示
  postIdCounter: number;
  setPostIdCounter: React.Dispatch<React.SetStateAction<number>>;
};
const MultiInputDetail: FC<Props> = (props) => {
  const { addPostsAllWorkers } = useAddPosts();
  const navigation = useNavigate();
  const addPosts = useAddPosts();
  // const deletePosts = useDeletePosts();
  // const updatePosts = useUpdatePosts();
  const addButtonRef = useRef<HTMLDivElement>(null);
  const targetRef = useRef<HTMLDivElement>(null);
  const scrollRef = useRef<HTMLDivElement>(null);
  const [recoilDairyList, setRecoilDiaryList] =
    useRecoilState<Dirary[]>(diaryListState);

  const [recoilDiaryListForMatrix, setRecoilDiaryListForMatrix] =
    useRecoilState<Dirary[]>(diaryListStateForMatrix);
  //二重送信ガード(同期 ref で再入防止 + 送信中フラグ)
  const { isSubmitting, runGuarded } = useSubmitGuard();
  const {
    diaryList,
    setDiaryList,
    totalTime,
    setTotalTime,
    defaultDiary,
    isSendable,
    // deleteDiaryList,
    // addDiaryList,
    // updateDiaryList,
    setWorkerList,
    workerList,
    fromTime,
    shiftType,
    isOverMaxChain,
    postIdCounter,
    setPostIdCounter,
  } = props;
  const [addButtonDisabled, setAddButtonDisabled] = useState(true);
  //新規発行IDカウンタ
  // const [newId, setNewId] = useState(-1);
  const theme = useTheme();
  // const [totalTime, setTotalTime] = useState({
  //   hour: 0,
  //   min: 0,
  //   text: "00時間00分",
  // });
  //更新ボタンが押されたときのイベント
  const onSave = () =>
    runGuarded(async () => {
      //一括は追加のみ。BE await 化済のため戻り値で成否を判定できる(null=失敗)
      const res = await addPostsAllWorkers(diaryList, workerList);
      //失敗時は遷移しない(フックが既に alert 済)
      if (res == null) return;
      //成功したらメイン画面を表示する(remount で一覧は再取得される)
      navigation('/');
    });

  //追加ボタンが押されたときのイベント
  const handleClickAddButton = () => {
    if (diaryList.length === 0) {
      //日報が１つも存在しない場合
      const newDiary = { ...defaultDiary, id: postIdCounter };
      setDiaryList((prevList) => [...prevList, newDiary]);
      setPostIdCounter((preCounter) => preCounter - 1);
    } else {
      //日報が存在する場合
      const newDiaryList = [...diaryList];
      const newDiary = { ...defaultDiary, id: postIdCounter };
      newDiaryList.push(newDiary);
      setDiaryList(newDiaryList);
      setPostIdCounter((preCounter) => preCounter - 1);
    }
  };
  useEffect(() => {
    if (
      workerList.length === 0 ||
      workerList.some((worker) => worker.isDiaryExist === true)
    ) {
      setAddButtonDisabled(true);
    } else {
      setAddButtonDisabled(false);
    }
  }, [workerList]);
  useEffect(() => {
    // 追加ボタンの位置までスクロール
    if (addButtonRef.current) {
      addButtonRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'center',
      });
    } else {
      console.log('addButtonRef.current is null');
    }
  }, [diaryList.length]);
  return (
    <div className={classes.rootContainer}>
      <div className={classes.header}>
        <div className={classes.totalTime}>
          <p>合計作業時間</p>
          <div
            style={{
              color:
                totalTime.hour <= 0
                  ? theme.palette.error.main
                  : theme.palette.foreColor.main,
              // theme.palette.foreColor.main,
            }}
          >
            {totalTime.text}
          </div>
        </div>

        {/* 夜勤2直対応(brush-up): チェーンが24時間を超えると送信不可。理由を赤チップで表示(F5-1) */}
        {isOverMaxChain && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              border: `1px solid ${theme.palette.error.main}`,
              color: theme.palette.error.main,
              borderRadius: '6px',
              padding: '2px 8px',
              fontSize: '12px',
              fontWeight: 'bold',
              whiteSpace: 'nowrap',
            }}
          >
            <WarningAmberIcon sx={{ fontSize: 16 }} />
            24時間を超えています
          </div>
        )}

        <div className={classes.updateButton}>
          <p>更新</p>
          <Buttons
            disabled={!isSendable || isSubmitting}
            onClick={onSave}
            caption={'更新'}
            icon={<SendIcon />}
            width={26}
            height={26}
            fontSize={24}
          />
        </div>
      </div>
      <div className={classes.detail} ref={scrollRef}>
        <div ref={targetRef}></div>
        {diaryList.map((diary, index) => (
          <MultiInputItem
            key={diary.id}
            id={diary.id}
            diaryList={diaryList}
            setDiaryList={setDiaryList}
            setTotalTime={setTotalTime}
            fromTime={fromTime}
            shiftType={shiftType}
          />
        ))}
        <div className={classes.addButton} ref={addButtonRef}>
          <Buttons
            disabled={addButtonDisabled}
            onClick={handleClickAddButton}
            caption={''}
            icon={<AddCircleIcon />}
            width={24}
            height={24}
            fontSize={24}
          />
        </div>
        <ScrollButton targetElm={targetRef} scrollElm={scrollRef} />
      </div>
    </div>
  );
};

export default MultiInputDetail;
